import { render, staticRenderFns } from "./TaskTeamSelector.vue?vue&type=template&id=7972f16b&"
import script from "./TaskTeamSelector.vue?vue&type=script&lang=js&"
export * from "./TaskTeamSelector.vue?vue&type=script&lang=js&"
import style0 from "./TaskTeamSelector.vue?vue&type=style&index=0&id=7972f16b&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7972f16b')) {
      api.createRecord('7972f16b', component.options)
    } else {
      api.reload('7972f16b', component.options)
    }
    module.hot.accept("./TaskTeamSelector.vue?vue&type=template&id=7972f16b&", function () {
      api.rerender('7972f16b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/TaskTeamSelector.vue"
export default component.exports